import { Typography } from '@mui/material'
import React from 'react'

import { MUIExternalLink } from 'components/common/MUIExternalLink'
import Icon from 'components/Icon'
import { NodeSectionType } from 'components/scenarios/utils/graph/messaging'
import { muiTheme } from 'mui-theme'

const TREE_NODE_SECTION_DESCRIPTION_STYLE = {
  marginLeft: 1,
  width: 650
}

export const ConcurrentTreeNodeSectionDescription: React.FC<{
  sectionType: NodeSectionType
}> = ({ sectionType }) => {
  switch (sectionType) {
    case NodeSectionType.Observers:
      return (
        <Typography sx={TREE_NODE_SECTION_DESCRIPTION_STYLE}>
          These Health Checks will be polled continuously during the entire
          Scenario.
        </Typography>
      )
    case NodeSectionType.ExternalActions:
      return (
        <Typography sx={TREE_NODE_SECTION_DESCRIPTION_STYLE}>
          <>
            Gremlin can automate some{' '}
            <MUIExternalLink href="https://www.gremlin.com/docs/fault-injection-scenarios#external-actions">
              external steps{' '}
              <Icon
                css={{
                  fontSize: muiTheme.typography.body2.fontSize
                }}
                icon="arrowUpRightFromSquare"
              />
            </MUIExternalLink>{' '}
            for this Scenario. The external steps will be run in the order they
            are entered. Gremlin will automatically generate your rollback steps
            for these actions.
          </>
        </Typography>
      )
    case NodeSectionType.Nodes:
      return (
        <Typography sx={TREE_NODE_SECTION_DESCRIPTION_STYLE}>
          These are the fault injection steps that Gremlin provides.
        </Typography>
      )
    case NodeSectionType.ExternalRollbacks:
      return (
        <Typography sx={TREE_NODE_SECTION_DESCRIPTION_STYLE}>
          These steps are automatically generated if external steps are added.
        </Typography>
      )
    default:
      return null
  }
}
